import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-apollo';
import styled from '@emotion/styled';
import {
  CircularProgress,
  Step,
  StepLabel,
  Stepper,
} from '@material-ui/core';
import ModalSlider from '../../../components/modal-slider/modal-slider';
import Button from '../../../components/button';
import { removeMasks } from '../../../utils/removeMask';
import {
  CREATE_PACIENTE_COMERCIAL,
  UPDATE_PACIENTE_COMERCIAL,
} from '../../../graphql/mutations';
import Notification from '../../../components/notification/Notification';
import { CartaoForm, DadosForm, PlanoList } from './components';
import { EnderecoForm } from './components/endereco-form';
import { ConfirmDados } from './components/confirm-dados';
import { FIND_WHITE_LABEL } from '../../../graphql/queryes';
import string from '../../../utils/string';
import { createUsuarioPaciente } from '../../../services/vizi-paciente';

const notificationDefault = {
  variant: '',
  message: '',
  isOpen: false,
};
const stepsEditPlanos = [
  {
    label: 'Dados do usuário',
    value: 0,
    key: 'dados_usuario',
    component: DadosForm,
  },
  {
    label: 'Planos',
    value: 1,
    key: 'planos',
    component: PlanoList,
  },
  {
    label: 'Endereço',
    value: 2,
    key: 'endereco',
    component: EnderecoForm,
  },
  {
    label: 'Confirmar Dados',
    value: 3,
    key: 'confirma_dados',
    component: ConfirmDados,
  },
];
const stepsPlanos = {
  NORMAL: [
    {
      label: 'Dados do usuário',
      value: 0,
      key: 'dados_usuario',
      component: DadosForm,
    },
    /*{
      label: 'Endereço',
      value: 2,
      key: 'endereco',
      component: EnderecoForm,
    },*/
    {
      label: 'Confirmar Dados',
      value: 1,
      key: 'confirma_dados',
      component: ConfirmDados,
    },
    /*
    {
      label: 'Dados do cartão',
      value: 4,
      key: 'cartao',
      component: CartaoForm,
    },
    */
  ],
  TAIP_SAUDE: [{
    label: 'Dados do usuário',
    value: 0,
    key: 'dados_usuario',
    component: DadosForm,
  },],
  DR_ATENDE: [
    {
      label: 'Dados do usuário',
      value: 0,
      key: 'dados_usuario',
      component: DadosForm,
    },
    {
      label: 'Planos',
      value: 1,
      key: 'planos',
      component: PlanoList,
    },
    /*{
      label: 'Endereço',
      value: 2,
      key: 'endereco',
      component: EnderecoForm,
    },*/
    {
      label: 'Confirmar Dados',
      value: 2,
      key: 'confirma_dados',
      component: ConfirmDados,
    },
    /*
    {
      label: 'Dados do cartão',
      value: 4,
      key: 'cartao',
      component: CartaoForm,
    },
    */
  ],
};

export const ModalCadastroPaciente = ({
  isOpen,
  handleClose,
  dadosPaciente,
  atualizarPacienteList,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [dadosCadastrais, setDadosCadastrais] = useState({
    ativo: dadosPaciente.id ? dadosPaciente.ativo : true,
  });
  const [notification, setNotification] = useState({
    ...notificationDefault,
  });
  const [stepSelected, setStepSelected] = useState(0);
  const [pacienteId, setPacienteId] = useState(dadosPaciente.id || null);
  const { data: dadosWhiteLabel } = useQuery(FIND_WHITE_LABEL);
  const whitelabelData = dadosWhiteLabel?.findEntidadeLogada?.whitelabel
  const whitelabel = 'DR_ATENDE';

  const checkStep = () => {

    switch (whitelabelData?.nome) {
      case 'TAIP_SAUDE':
        return stepsPlanos['TAIP_SAUDE'];
      case 'DR_ATENDE':
        return stepsPlanos['DR_ATENDE']
      default:
        return stepsPlanos['NORMAL'];
    }
  };

  const handleDadosCadastrais = (value, field) => {
    setDadosCadastrais((prevState) => {
      return {
        ...prevState,
        [field]: value,
      };
    });
  };
  const [criarPacienteComercial] = useMutation(CREATE_PACIENTE_COMERCIAL);
  const [atualizarPacienteComercial] = useMutation(UPDATE_PACIENTE_COMERCIAL);

  const renderContent = () => {
    const steps = checkStep();
    const step = steps[stepSelected];
    const Component = step.component;
    return (
      <Component
        dadosCadastrais={{ ...dadosCadastrais }}
        whitelabel={whitelabelData?.nome}
        pacienteId={pacienteId}
        handleDadosCadastrais={handleDadosCadastrais}
        onClose={() => handleClose()}
      />
    );
  };

  /*const createPacienteWhitelabel = (variables) => {
    switch (whitelabel) {
      case 'DR_ATENDE':
        return createUsuarioPaciente(variables);

      default:
        return criarPacienteComercial({ variables });
    }
  }; será usado no futuro quando necessitar criar o paciente com plano*/
  const variablesPacienteWhitelabel = (variables) => {
    const dadosplano= dadosCadastrais?.plano
    if(whitelabelData?.nome !== 'DR_ATENDE'){
      delete dadosplano?.valorMulta;
      delete dadosplano?.diasCarencia;
    }

    const variablesCadastroWithoutPlano = {
      paciente: {
        ...(dadosPaciente?.id ? { id: dadosPaciente?.id } : {}),
        nome: dadosCadastrais.nome,
        email: dadosCadastrais.email,
        cpf: removeMasks(dadosCadastrais.cpf),
        telefonePrincipal: removeMasks(dadosCadastrais.telefone),
        ativo: dadosCadastrais.ativo,
       ...(whitelabelData?.nome === 'DR_ATENDE' && { planoVizi:[{
          dataFimPlano: dadosCadastrais.dataFimPlano,
          dataInicioPlano: dadosCadastrais.dataInicioPlano,
          planoVizi: dadosplano
        }]})
      },
    };

    /*const variablesCadastroWithPlano = {
      paciente: {
        ...(dadosPaciente?.id ? { id: dadosPaciente?.id } : {}),
        pacienteTitular: dadosCadastrais.pacienteTitular || null,
        nome: dadosCadastrais.nome,
        email: dadosCadastrais.email,
        documento: removeMasks(dadosCadastrais.cpf),
        telefonePrincipal: removeMasks(dadosCadastrais.telefone),
        ativo: dadosCadastrais.ativo,
        endereco: {
          estado: {
            nome: dadosCadastrais.endereco.nome,
            id: dadosCadastrais.endereco.id,
            uf: dadosCadastrais.endereco.uf,
          },
          municipio: {
            nome: dadosCadastrais.endereco.nome,
            id: dadosCadastrais.endereco.id,
            uf: dadosCadastrais.endereco.uf,
          },
        },
        planoAtivo: {
          id: dadosCadastrais.plano.id,
        },
      },
      cartaoCredito: null,
      numParcelas: 1,
    };
    switch (whitelabel) {
      case 'DR_ATENDE':
        return variablesCadastroWithPlano;

      default:
        return variablesCadastroWithoutPlano;
    } utilizar quando for cadastrar pacientes vinclando a planos*/
     return variablesCadastroWithoutPlano
  };

const hasCampoVazio = () => {
    const {
      nome,
      cpf,
      email,
      telefone,
      plano,
    } = dadosCadastrais || {};
    /*const { nomeLogradouro, bairro, cep, estado, municipio } = endereco || {};
    const {
          nomeLogradouro,
          bairro,
          cep,
          estado,
          municipio,
          numero} =  enderecoCobranca || {}*/

    const campoInexistenteDadosPessoais = !nome || !cpf || !email || !telefone;
  const planoInexistente = (!plano?.id && whitelabel?.nome === 'DR_ATENDE');
    /*const campoInexistenteEndereco =
      !nomeLogradouro || !bairro || !cep || !estado || !municipio;
    const campoInexistenteCartao = !holder || !cardNumber || !securityCode;*/

    switch (stepSelected) {
      case 0:
        return campoInexistenteDadosPessoais;
      case 1:
        return  planoInexistente;
      /*case 2:
        return campoInexistenteEndereco;
        */
      default:
        return false;
    }
  };
  const verifyFields = () =>{
     const isEmptyField = hasCampoVazio();
     const verifyEmail =  !string.validaEmail(dadosCadastrais.email)
    if (isEmptyField) {
      setNotification({
        isOpen: true,
        variant: 'error',
        message: 'Todos os campos devem ser preenchidos.',
      });
      return false;
    }
     if (verifyEmail) {
      setNotification({
        isOpen: true,
        variant: 'error',
        message: 'Digite um email válido.',
      });
      return false;
    }
    return true
  };

  const handleClickStep = (step) => {
    if(step === 4) return
    const checkedFields = verifyFields()
    if(!checkedFields) return
    setStepSelected(step);
  };

  const handleNext = () => {
    const checkedFields = verifyFields()
    if(!checkedFields) return

    setStepSelected((step) => (step < 5 ? step + 1 : step));
  };

  const checkSaveButton = () => {
    return (
      stepSelected === 2 ||
      numberSteps === 1 ||
      (numberSteps === 2 && stepSelected === 1) ||
      (dadosCadastrais?.id && stepSelected === 2)
    );
  };

  const handleClickSave = async () => {
    const campoInexistes = hasCampoVazio();

    if (campoInexistes) {
      setNotification({
        isOpen: true,
        variant: 'error',
        message: 'Todos os campos devem ser preenchidos',
      });
      return;
    }

    try {
      setLoadingSave(true);
      const variables = variablesPacienteWhitelabel();
      const response = dadosCadastrais?.id
        ? await atualizarPacienteComercial({variables})
        : await criarPacienteComercial({variables});
      if (
        response.data?.updatePacienteComercial?.id ||
        response.data?.createPacienteComercial?.id
      ) {
        setNotification({
          isOpen: true,
          variant: 'success',
          message: dadosCadastrais?.id
            ? 'Dados atualizados com sucesso!'
            : 'Paciente cadastrado com sucesso!',
        });
        setPacienteId(
          response.data?.updatePacienteComercial?.id ||
            response.data?.createPacienteComercial?.id
        );
      }
    } catch (e) {
      console.error(e);
      setNotification({
        isOpen: true,
        variant: 'error',
        message: 'Não foi possível cadastrar o paciente',
      });
    } finally {
      setLoadingSave(false);
      /*handleNext();*/
      atualizarPacienteList();
    }
  };
  useEffect(() => {
    if (dadosPaciente.id) {
      setDadosCadastrais({ ...dadosPaciente });
      setPacienteId(dadosPaciente.id);
      return;
    }
    setStepSelected(0);
    setDadosCadastrais({});
  }, [dadosPaciente.id]);
  useEffect(() => {
    if (dadosPaciente.isPayment) {
      setDadosCadastrais({ ...dadosPaciente });
      setStepSelected(4);
      return;
    }
  }, [dadosPaciente.isPayment]);

  const whitelabelSteps = checkStep();
  const numberSteps = whitelabelSteps.length;

  return (
    <>
      <ModalSlider
        isOpen={isOpen}
        onClose={handleClose}
        title={`${dadosCadastrais?.id ? 'Informações do' : 'Novo'} paciente`}
      >
        {dadosCadastrais?.pacienteTitular?.nome && (
          <span>{dadosCadastrais.pacienteTitular.nome}</span>
        )}
        <ContentModal>{renderContent()}</ContentModal>

        <Footer>
            {numberSteps > 1 && (
              <StepperStyle activeStep={stepSelected} alternativeLabel>
                {whitelabelSteps.map((step) => (
                  <StepStyle
                    key={step.key}
                    onClick={() => handleClickStep(step.value)}
                  >
                    <StepLabel style={{ cursor: 'pointer' }}>
                      {step.label}
                    </StepLabel>
                  </StepStyle>
                ))}
              </StepperStyle>
            )}
            {stepSelected < 3 && (
            <WrapperButton>
              <Button
                disabled={loadingSave}
                onClick={checkSaveButton() ? handleClickSave : handleNext}
              >
                {checkSaveButton() ? 'Salvar' : 'Próximo'}
                {loadingSave && <CircularProgress color="#fff" size={12} />}
              </Button>
            </WrapperButton>
            )}
            {/*<Button
                disabled={loadingSave}
                onClick={ handleClickSave }
              >
                Salvar
                {loadingSave && <CircularProgress color="#fff" size={12} />}
              </Button>*/}
          </Footer>

      </ModalSlider>
      <Notification
        close={() => {
          setNotification({
            ...notificationDefault,
          });
        }}
        reset={() => {
          setNotification({
            ...notificationDefault,
          });
        }}
        isOpen={notification.isOpen}
        variant={notification.variant}
        message={notification.message}
      />
    </>
  );
};

const Footer = styled.div`
  min-height: max-content;
  padding-top: 16px;
  display: grid;
  gap: 16px;
  grid-template-columns: 3fr 1fr;
  align-items: center;
`;

const StepperStyle = styled(Stepper)`
  padding: 0px !important;
`;

const StepStyle = styled(Step)`
  .MuiStepLabel-label {
    font-size: 0.6rem;
  }
`;

const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
  height: 70vh;
`;

const WrapperButton = styled.div`
  display:flex
`
